<template>
  <component
    :is="'script'"
    v-once
    type="application/ld+json"
    v-html="jsonld"
  />
</template>

<script>
  export default {
    props: {
      jsonld: {
        type: Object,
        required: true
      }
    }
  }
</script>
